import React, { memo } from 'react'

import { arrayOf, string } from 'prop-types'

import { FEATURES, PRINT_FEATURES } from 'Pods/SearchPage/Shared/FeaturesContent/constants'
import useTranslate from 'Pods/SearchPage/Shared/useTranslate'
import { useSearchPageStore } from 'Pods/SearchPage/Store'
import { ASSET_TYPE } from 'Pods/SearchPage/Store/constants'

import { EMPTY_ARRAY } from 'Utils/stableDefaults'

import Categories from './Components/Categories/Categories'
import Features from './Components/Features/Features'
import PolyCount from './Components/PolyCount/PolyCount'
import PrintAttributes from './Components/PrintAttributes/PrintAttributes'
import SearchWithinResults from './Components/SearchWithinResults/SearchWithinResults'
import Style from './Components/Style/Style'
import TagSuggestions from './Components/TagSuggestions/TagSuggestions'
import TechnicalAttributes from './Components/TechnicalAttributes/TechnicalAttributes'

// Contextual bar shown when an asset type is selected; reflows by width (CSS-driven).
function SecondaryFilters({ suggestedTags = EMPTY_ARRAY }) {
  const translate = useTranslate()

  const assetType = useSearchPageStore(state => state.assetType)

  if (assetType === ASSET_TYPE.ALL) return null

  const is3DOnly = assetType === ASSET_TYPE.THREE_D_ONLY
  const is3DPrintOnly = assetType === ASSET_TYPE.THREE_D_PRINT_ONLY

  return (
    <div
      className="secondary-filters"
      role="group"
      aria-label={translate('search_page.filters.secondary.group_label')}
    >
      <div className="secondary-filters__left">
        {/* Each asset type consolidates its own controls under Features (3D: Animated, PBR, ...;
            print: Has Makes, ...), so a print search never emits 3D params alongside `printable`.
            Same lists as the More filters drawer. */}
        {(is3DOnly || is3DPrintOnly) && (
          <div className="secondary-filters__consolidated">
            <Features features={is3DPrintOnly ? PRINT_FEATURES : FEATURES} />
          </div>
        )}
        <Style />
        {is3DOnly && (
          <div className="secondary-filters__poly">
            <PolyCount />
          </div>
        )}
        {is3DOnly && (
          <div className="secondary-filters__expanded">
            <TechnicalAttributes />
          </div>
        )}
        {is3DPrintOnly && (
          <div className="secondary-filters__expanded">
            <PrintAttributes />
          </div>
        )}
      </div>
      <div className="secondary-filters__divider" aria-hidden="true" />
      <div className="secondary-filters__middle">
        <SearchWithinResults />
      </div>
      <div className="secondary-filters__right">
        <div className="secondary-filters__consolidated">
          <Categories />
        </div>
        <div className="secondary-filters__tags">
          <TagSuggestions suggestedTags={suggestedTags} />
        </div>
      </div>
    </div>
  )
}

SecondaryFilters.propTypes = {
  suggestedTags: arrayOf(string),
}

export default memo(SecondaryFilters)
